export default (arr, key) => {
    let sum = 0;

    arr.forEach(el => {
        sum += el[key] ? +el[key] : 0
    })

    return sum
}